const DATEPICKER = {
    // Strings and translations
    monthsFull: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    weekdaysFull: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    // showMonthsShort: undefined,
    // showWeekdaysFull: undefined,

    // Buttons
    today: 'Hoje',
    clear: 'Limpar',
    close: 'Fechar',

    // Accessibility labels
    labelMonthNext: 'Próximo mês',
    labelMonthPrev: 'Mês anterior',
    labelMonthSelect: 'Selecionar o mês',
    labelYearSelect: 'Selecionar o ano',

    format: 'dd/mm/yyyy',
    formatSubmit: 'dd/mm/yyyy'
};
export default DATEPICKER;


// WEBPACK FOOTER //
// ./src/constants/datepicker.js